import React from 'react';

const AtaturkAnsiklopedisi = () => {
  return (
    <div>
      <p style={{ textAlign: 'center', fontSize: '12pt', fontFamily: '"Times New Roman", serif', fontWeight: 'bold' }}>
        ATATÜRK ANSİKLOPEDİSİ MADDE YAZIM İLKELERİ, TEKLİFİ, SÖZLÜK VE ANSİKLOPEDİ YÖNETİM SİSTEMİ (SAYS) KULLANIM VE MADDE YÜKLEME YÖNERGESİ
      </p>

      <p style={{ textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        Yayın hayatına 29 Ekim 2020 yılında başlayan Atatürk Ansiklopedisi, çevrimiçi ortamda{' '}
        <a href="https://ataturkansiklopedisi.gov.tr/" style={{ color: 'blue', textDecoration: 'underline' }}>
          https://ataturkansiklopedisi.gov.tr/
        </a>{' '}
        adresi üzerinden yayımlanır.
      </p>

      <h3 style={{ fontWeight:'bold', textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        1. Ansiklopedinin Yayın Amacı
      </h3>
      <p style={{ textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        Mustafa Kemal Atatürk’ün doğumundan başlayarak <span style={{ color: 'black' }}>1960</span>
        ’a kadar olan süreç içerisinde Türkiye tarihini ilgilendiren olaylar, olgular, kurumlar ve şahsiyetler hakkında
        doğru bilgiyi kamuoyu ile paylaşmaktır.
      </p>

      <h3 style={{fontWeight:'bold',  textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        2. Ansiklopedinin Konusu
      </h3>
      <p style={{ textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        Birinci aşamada Mustafa Kemal Atatürk’ün doğumundan vefatına kadar devam eden süre içinde Atatürk’ün yaşadığı
        mekânlar (beşerî ve fiziki), başlattığı, yönettiği ya da yönlendirdiği ve Türkiye’nin geleceğinin
        biçimlenmesinde ve toplumun yapılanmasında etkili olan olay ve olgular, Atatürk’ün gerçekleştirdiği eylemlerle
        doğrudan ilgili olan şahsiyetler hakkındaki yazıları içermektedir. İkinci aşamada ise Mustafa Kemal Atatürk’ün
        vefatından 1960’a kadar olan süreç içerisinde Türkiye tarihini ilgilendiren olaylar, olgular, kurumlar ve
        şahsiyetlere dair çalışmaları barındırmaktadır.
      </p>

      <h3 style={{ textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        3. Ansiklopedi İçeriğinde Yer Alacak Çalışmalar
      </h3>
      <p style={{ textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        Ansiklopedi için belirlenen zaman aralığına uygun, birincil kaynaklara dayandırılarak hazırlanan yazılar
        olmalıdır.
      </p>
      <p style={{ textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: 'black' }}>
        Gönderilecek olan metinler alanında çalışma sahibi olan yazarlar tarafından hazırlanmalı ve ansiklopedi madde
        formatına uygun olarak daha önce başka bir yayın organında yayımlanmamış ya da ansiklopedi formatına göre
        yeniden yazılmış olmalıdır.
      </p>

      <h3 style={{fontWeight:'bold',  textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        4. Maddelerin Değerlendirilmesi
      </h3>
      <p style={{ textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        Gelen metinler, Madde Takip Görevlisi (MTG) tarafından yazım kurallarına uygunluğu bakımından şekil olarak
        kontrol edildikten sonra yazım kurallarına herhangi bir aykırılık yoksa Atatürk Ansiklopedisi Komisyon
        (Çalışma Grubu) gündemine eklenir. Çalışma Komisyonu tarafından yayımlanması uygun görülmeyen yazıların
        yazarlarına herhangi bir telif ücreti ödemesi yapılmaz.
      </p>
      <p>
        <span style={{ fontSize: '12pt', backgroundColor: 'white', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          Maddenin genel olarak aşağıda belirtilen düzene göre sisteme yüklenmesine özen gösterilmelidir:
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          1- Başlık (Yazılan madde bir kişinin anlatımı ise doğum ve vefat tarihleri başlıktan sonra verilmelidir. Madde bir olay ise yine başlıktan sonra meydana geldiği tarih yazılmalıdır.)
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          2- Tanım
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          3- Anahtar Kelimeler (En az 4, en çok 8 anahtar kelime alfabetik sıra ile verilmelidir.)
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          4- Özet
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          5- Ana Metin
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          6- Kaynakça
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          7- Madde Görseli Yüklemesi
        </span>
      </p>

      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          8- Madde Word Dosyasının Yüklemesi
        </span>
      </p>

      <h3 style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        6.2. Özet
      </h3>
      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          En fazla 200 kelime olacak şekilde Türkçe olarak ayrı yazılmalıdır. Öz, maddenin ana fikrini ve maddeyi tanıtacak nitelikte olmalıdır.
        </span>
      </p>

      <h3 style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        6.3. Ana Metin
      </h3>
      <p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
    
       
        Madde ana metni, Sözlük ve Ansiklopedi Yönetim Sisteminde (SAYS) “Madde Metni”
kısmına bir kompozisyon Ģeklinde, kolay okunabilir özellikte ansiklopedi madde formatında
girilmelidir. Metinde gereğinden fazla alıntılara yer verilmemesi gerektiği gibi yazarın kendi
ifadeleri de alıntı metne dahil edilmemelidir. Yazı bir bütünlük içinde tematik ve kronolojik
bağlamda bir bütünde ele alınmalıdır. Metnin yazılmasında kurulan cümleler kısa olmalı
metinde kullanılan kelimelere ise günümüz okuyucusunun anlayabileceği sadelikte olmalıdır.
Hakkında yazı yazılan kiĢilerin övgüsü veya yergisi yapılmamalıdır. KiĢi ve olayların Atatürk
Ansiklopedisi'nde "madde" olmasını sağlayan yönleri, öncelikle ele alınmalıdır.
Metin içinde geçen eser, gazete ve dergi isimlerinin italik yazılması, TDK yazım kurallarına
uyulması (örneğin "Dahi", "bile" anlamına gelen "de", "da" kelimeleri öncesindeki kelimeden ayrı
yazılmalıdır. Bağlaç olan "ki"nin ayrı yazılmasına dikkat edilmelidir) ve öznel, değer yüklü
ifadelerden kaçınılması gerekmektedir.
     
      </p>

      <h3 style={{ fontWeight:'bold', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        6.4. Bölüm Başlıkları
      </h3>
      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          Atatürk Ansiklopedisi madde metininde ara/alt başlık vb. kullanılmamalıdır.
        </span>
      </p>

      <h3 style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        6.5. Alıntılar
      </h3>
      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          Metinde gereğinden fazla alıntılara yer verilmemesi gerektiği gibi alıntılar tırnak içinde veya italik verilmelidir...
        </span>
      </p>

      <h3 style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        6.6. Atıf Gösterme
      </h3>
      <p>
        <span style={{ fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
          Metin içerisinde dipnot kullanılmamalıdır. Maddenin yazımında kullanılan kaynaklar kaynakçada belirtilmelidir.
        </span>
      </p>

      <h3 style={{ fontWeight:'bold', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
        6.7. Kaynakça Yazımı
      </h3>
      <p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
      Maddede kullanılan kaynaklar SAYS’ta “Kaynakça” kısmına girilmelidir. Kaynaklar ilgisine göre sırasıyla “Arşiv Belgeleri ve Resmî Eserler”, “Süreli Yayınlar”, “Telif, Tetkik ve Elektronik… vb. Kaynaklar” başlıkları altında sınıflandırılarak her birisi kendi içerisinde alfabetik olacak şekilde verilmelidir.
</p>
<p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
Arşiv Belgeleri ve Resmî Belgelerde kullanılan arşiv kaynaklarının fon kodları ve belge numaraları mutlaka belirtilmelidir. Süreli Yayınların tarihleri özellikle yazılmalıdır.
</p>
<p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}><span style={{fontWeight:'bold'}}> a-Kitap</span>: YAZARIN SOYADI, Yazarın Adı, Kitabın Adı (koyu karakterde), (varsa) Cilt, Yayınevi, Yayın Yeri ve Tarihi verilmelidir.</p>
<h3 style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif'}}>Örnek 1:</h3>
<p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
SARAY, Mehmet,<span style={{fontWeight:'bold'}}> Türk-İran İlişkileri </span>, Atatürk AraĢtırma Merkezi Yayınları, Ankara 1999.
b-Makale: YAZARIN SOYADI, Yazarın Adı, Makalenin Adı (tırnak içinde), Ġçinde yer
Aldığı Yayının Adı (koyu karakterde), Cilt (C), Sayı (S), Yayın Yeri ve Yılı, Sayfa Aralığı
verilmelidir.
</p>
<h3  style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif'}}>Örnek 2:</h3>
<p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
TOKLUOĞLU, Ceylan, “Ziya Gökalp: Turancılıktan Türkçülüğe”, <span style={{fontWeight:'bold'}}>Atatürk Araştırma
Merkezi Dergisi </span>, C XXVIII, S 84, Ankara 2013, s.103-142.
Çok yazarlı kitap ya da makaleler, kaynakçada gösterilirken bütün yazar adları yazarların
adları araya virgül gelecek Ģekilde yazılarak belirtilmelidir.
</p>

<h3  style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif'}}>Örnek 3:</h3>
<p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>

(İkiden fazla yazarlı) SOFUOĞLU, Adnan-YILDIRIM, Seyfi, <span style={{fontWeight:'bold'}}>Arşiv Vesikalarına Göre 1921 Londra Konferansı Tutanaklar-Belgeler </span>, 
Atatürk Araştırma Merkezi Yayınları, Ankara 2018.
<span style={{fontWeight:'bold'}}>c-Bildiri</span>: YAZAR(LAR)IN SOYADI, Yazar Adı, Bildirinin Başlığı (tırnak içinde), Sempozyumun veya Kongrenin Adı, Düzenlendiği Yerin Adı, Düzenlenme Tarihi, Bildiriler, varsa Editörün Adı, Cilt, Basımevi/Yayınevi, Yayın Yeri ve Tarihi, Sayfa Aralığı.
</p>
  <h3  style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif'}}>Örnek 4:</h3>
<p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
ŞİMŞİR, Bilal N., “Atatürk ve Avusturalya”,<span style={{fontWeight:'bold'}}> Altıncı Uluslararası Atatürk Kongresi, Ankara, 12-16 Kasım 2007, Bildiriler,</span> C I, Atatürk Araştırma Merkezi Yayınları, Ankara 2010, s.35-73.
<span style={{fontWeight:'bold'}}>b-Arşiv Belgesi</span>: Her bir arşiv belgesi ayrı ayrı olacak şekilde arşiv adı ve fon kodları açık olacak şekilde yazılmalıdır. 
</p>
<h3  style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif'}}>Örnek 5:</h3>
<p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
<span style={{fontWeight:'bold'}}>Türkiye Cumhuriyeti Cumhurbaşkanlığı Devlet Arşivleri Başkanlığı Cumhuriyet Arşivi (BCA) </span> , 30-10-0-0/ 183-261-20, 11.08.1925. veya (BCA), 30.18.1.1/13.20.18.(31.03.1925) şeklinde belge tarihi varsa (/), (virgül) ya da parantez içinde verilmelidir. 
*Mülakat ve röportaj tarzı görüşmeler, Kaynakçada gösterilmelidir.
  
      </p>

      <h3 style={{fontWeight:'bold',  fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
       7. Madde Teklifi
      </h3>
      <p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
      Madde teklifi/önerisi de<a href="https://giris.ayk.gov.tr/signin">https://giris.ayk.gov.tr/signin </a>  adresi üzerinden SAYS’a girilerek “madde öner” bölümünden yapılmalıdır. Öneride bulunurken maddenin Ansiklopedide yer alıp almadığının kontrol edilmesi ve madde teklifi Ansiklopedide yoksa neden ansiklopedide yer alması gerektiğinin gerekçesi detaylı bir şekilde izah edilmelidir. Madde, öneren kişi tarafından yazılmak isteniliyorsa belirtilmeli ya da başkası tarafından yazılabileceği düşünülüyorsa da yazar ismi önerilmelidir. Maddenin bir kişi tarafından önerilmesi o maddenin o kişi tarafından yazılacağı anlamına gelmemektedir. Çalışma Grubunun farklı bir yazar ismi belirleme hakkı saklıdır. Yazar davetinde uzmanlık esas alınmaktadır. (Doktora tezi, kitap ve makale yazarlığı) gibi.

      </p>

      <h3 style={{ fontWeight:'bold', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
      8. Madde Daveti ve Yazıların Gönderilmesi      </h3>
      <p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
      Çalışma Grubu maddeleri yazabilecek kişileri belirledikten sonra SAYS üzerinden MTG tarafından yazarlara madde yazım daveti gönderir. Madde yazımı daveti gönderilen yazarların; maddeyi yazıp yazmayacaklarına ilişkin kararlarını ret ya da kabul şeklinde on (10) gün içinde SAYS üzerinden bildirmeleri gerekmektedir. Madde yazım daveti kabul edilirse madde yazımı için kendilerine dört (4) ay süre tanınır. Sipariş edilmiş ve/veya yazarından düzeltme talep edilmiş olan maddelerin yazım süresi de dâhil olmak üzere Kurumumuza teslim edilme süresinin aşılması durumunda yazar, madde yazımından çekilmiş kabul edilecektir.  </p>
      <p style={{ textAlign: 'justify',fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
      Yazarlar, ansiklopedi yayın ilkeleri, Türk Dil Kurumu (TDK) yazım kuralları ve TDK Güncel Türkçe Sözlüğüne uygun olarak hazırlanmış maddelerinin girişlerini SAYS üzerinden yaparlar. Yazarlar, Çalışma Grubunca ve Ansiklopediden sorumlu uzmanlarca esasa yönelik olmayan küçük düzeltmeler (değişikliklerin oranı hiçbir durumda ana metnin ¼’ünü geçmeyecektir) yapılabileceğini kabul etmiş sayılırlar.</p>
      <p style={{textAlign: 'justify', fontSize: '12pt', fontFamily: '"Times New Roman", serif', color: '#333333' }}>
      Madde SAYS’ta ilgili yerlere girildikten sonra A4 boyutunda, üst/alt/sağ/sol 2,5 cm sayfa kenarlığı boşluğu bırakılarak, cilt payı 0 cm olacak şekilde, paragrafın ilk satırı girintilenmeden, satır aralarında önce ve sonra 12nk 1,5 satır aralığı ile ve 11 punto (Öz ve Abstract 10 punto ile) Times New Roman yazı karakteri word programında hazırlanacak dosyalar doc/docx ve pdf uzantılı olarak ayrıca sisteme yüklenmelidir.  Madde görselleri de varsa yine ayrıca sisteme yüklenmelidir. Yazılar en fazla 3.500 kelimeden oluşmalıdır. Maddenin ihtiva ettiği konunun önemine göre bu sayı Çalışma Grubunca arttırılabilir veya azaltılabilir.
      </p>

    </div>
  );
};

export default AtaturkAnsiklopedisi;
